import type { ReactNode } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";
import { StyledColumn, StyledFlex } from "./layout";
import { Spacer } from "../Spacer";
import { TextCapitalized } from "../text/TextCapitalized";

export interface FooterMenuItem {
  label: string;
  icon: ReactNode;
  onClick: () => void;
  isSelected?: boolean;
}

export interface FooterMenuProps {
  items: FooterMenuItem[];
}

export const FooterMenu = ({ items }: FooterMenuProps) => (
  <StyledBar as="nav">
    {items.map((item) => (
      <StyledItem
        as="button"
        key={item.label}
        $isSelected={item.isSelected}
        onClick={item.onClick}
      >
        {item.icon}
        <Spacer y={0.25} />
        <StyledLabel>
          <TextCapitalized>{item.label}</TextCapitalized>
        </StyledLabel>
      </StyledItem>
    ))}
  </StyledBar>
);

const StyledBar = styled(StyledFlex)`
  /* Fill the space between the Page footer's side spacers (flex context),
     while staying full-width when used on its own. */
  flex: 1;
  width: 100%;
  min-width: 0;
`;

const StyledItem = styled(StyledColumn)<{ $isSelected?: boolean }>`
  align-items: center;
  /* Equal-width tabs that always share the bar, never overflow it. */
  flex: 1;
  min-width: 0;
  border: none;
  background: none;
  cursor: pointer;
  font: inherit;
  color: ${({ $isSelected }) =>
    $isSelected ? colors["colors/accent/500"] : colors["colors/text/darkGrey"]};

  svg {
    fill: currentColor;
  }
`;

const StyledLabel = styled.span`
  ${typographies["Body/XXXS"]}
  text-align: center;
`;
